import React from 'react';
import { useSelector } from 'react-redux';
import CardTodaysPromo from './CardTodaysPromo';
import fire from '../../assets/highlight-icon/fire.svg';
import MenuSlider from './MenuSlider';

const TodaysPromo = () => {
  const { items } = useSelector(state => state.highlight.todaysPromo);

  return (
    <div className='todays-promo'>
      <div className="todays-promo-head">
        <h2>Promo Hari Ini<span><img src={fire} alt="fire icon" /> <p>Hot!</p></span></h2>
        <div className="see-all-at-promo">Lihat Semua</div>
      </div>
      <MenuSlider />
      <div className="todays-promo-cards">
        {items.map(product => (
          <CardTodaysPromo key={product.name} img={product.img} alt={product.alt} productName={product.name} qty={product.qty} discount={product.discount} discountPrice={product.discountPrice} actualPrice={product.actualPrice} />
        ))}
      </div>
    </div>
  )
}

export default TodaysPromo
